import { render, staticRenderFns } from "./ImportPurchaseForm.vue?vue&type=template&id=7d646320&scoped=true&"
import script from "./ImportPurchaseForm.vue?vue&type=script&lang=js&"
export * from "./ImportPurchaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d646320",
  null
  
)

export default component.exports